import { useRef, useLayoutEffect } from "react";
import gsap from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";

import { v4 as uuid } from "uuid";

import { ReactComponent as LogoSVG } from "./animatedLogo.svg";
import useForceUpdate from "../../../Hooks/useForceUpdate";

gsap.registerPlugin(MotionPathPlugin);

export default function AnimatedProjectLogo({ className }) {
  const svg = useRef();

  const forceUpdate = useForceUpdate();

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap.to("#plane", {
        duration: 2,
        repeat: 0,
        motionPath: {
          path: "#track",
          align: "#track",
          autoRotate: -45,
          alignOrigin: [0.5, 0.5],
        },
      });
    }, svg);

    return () => ctx.revert();
  }, [forceUpdate]);
  return (
    <div style={{ cursor: "pointer" }} className={className}>
      <LogoSVG ref={svg} key={uuid()} onClick={forceUpdate} />
    </div>
  );
}
